import { createContext, useContext, useState, ReactNode, useCallback, useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { ORGANIZATION_STORAGE_KEY } from '../../constants';

type OrgDispatch = (id: string) => void;
const OrganizationContext = createContext<[string, OrgDispatch]>(['', () => {}]);

export function OrganizationProvider({ children }: { children: ReactNode }) {
    const [organization, setOrganization] = useState<string>(() => {
        return window.sessionStorage.getItem(ORGANIZATION_STORAGE_KEY) || '';
    });

    useEffect(() => {
        Sentry.setTag('organization_id', organization || 'unknown');
    }, [organization]);

    const dispatch = useCallback<OrgDispatch>((newOrg) => {
        window.sessionStorage.setItem(ORGANIZATION_STORAGE_KEY, newOrg);
        setOrganization(newOrg);
    }, []);

    return (
        <OrganizationContext.Provider value={[organization, dispatch]}>
            {children}
        </OrganizationContext.Provider>
    );
}

export function useOrganization(): [string, OrgDispatch] {
    return useContext(OrganizationContext);
}
